/**
 * hostname:port combinations (aka authority in URI terms) for each environment.
 */
export const ilHosts = {
  develop: 'localhost:7858',
  test: 'il-test.srgssr.ch',
  stage: 'il-stage.srgssr.ch',
  production: 'il.srgssr.ch'
};